module.exports = __webpack_public_path__ + "static/media/kw.a6e43536.webp";